export const SERVICE_AREA_SLUGS = [
  "new-york",
  "new-jersey",
  "pennsylvania",
  "connecticut",
  "florida",
  "texas",
  "california",
] as const;

export type ServiceAreaSlug = (typeof SERVICE_AREA_SLUGS)[number];

export type ConversionAttributionPayload = {
  eventId: string;
  sessionId: string;
  sourcePath: string;
  landingPath: string;
  serviceAreaSource?: ServiceAreaSlug;
  referrerDomain?: string;
  utmSource?: string;
  utmMedium?: string;
  utmCampaign?: string;
  utmTerm?: string;
  utmContent?: string;
};
